import { createApp } from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import './style.css';

import { createPinia } from 'pinia';
import { router } from './router';
import { injectPrivateRoutesByPermission } from './router/injectPrivateRoutesByPermission';

async function initializeApp() {
    const app = createApp(App);
    const pinia = createPinia();

    app.use(Antd);
    app.use(pinia);

    // 等權限與私有路由處理完再加載註冊 router
    await injectPrivateRoutesByPermission();
    app.use(router);
    app.mount('#app');
}

// 初始化應用程式
initializeApp().catch((error) => {
    console.error('應用程式初始化失敗:', error);
});
